export default "__VITE_ASSET__1f59fd2e__"